import { SCORING_PRIORITIES } from "../types/lead-priority";
import { ScoringConfigType, type ScoringConfigRule } from "../types/scoring-config";

type MergedScoringRules = {
    rules: ScoringConfigRule;
    ruleScopeById: Readonly<Record<string, ScoringConfigType>>;
};

const collectRuleIds = (rules: ScoringConfigRule): ReadonlySet<string> => {
    const ids = new Set<string>();

    for (const priority of SCORING_PRIORITIES) {
        for (const rule of rules[priority] ?? []) {
            if (rule.id) {
                ids.add(rule.id);
            }
        }
    }

    return ids;
};

export const mergeScoringRules = (
    userRules: ScoringConfigRule,
    accountRules: ScoringConfigRule,
): MergedScoringRules => {
    const ruleScopeById: Record<string, ScoringConfigType> = {};
    const accountRuleIds = collectRuleIds(accountRules);
    const rules: ScoringConfigRule = {};

    for (const priority of SCORING_PRIORITIES) {
        const userColumn = userRules[priority] ?? [];
        const accountColumn = accountRules[priority] ?? [];
        const mergedColumn = [];

        // User config includes private rules and shared-with-me rules. Skip user entries whose id
        // also exists in account config so shared rules are not duplicated in the merged board.
        for (const rule of userColumn) {
            if (!rule.id || accountRuleIds.has(rule.id)) {
                continue;
            }

            ruleScopeById[rule.id] = ScoringConfigType.User;
            mergedColumn.push(rule);
        }

        for (const rule of accountColumn) {
            if (!rule.id) {
                continue;
            }

            ruleScopeById[rule.id] = ScoringConfigType.Account;
            mergedColumn.push(rule);
        }

        if (mergedColumn.length > 0) {
            rules[priority] = mergedColumn;
        }
    }

    return { rules, ruleScopeById };
};
